module.exports = __webpack_public_path__ + "img/planet-neptune-internal.abc82659.svg";